import { queryOptions, keepPreviousData } from '@tanstack/react-query';
import HttpClient from '../../Api/HttpClient';
import handle401 from '../handle-401';
import config from '../../config';

const projectsListQuery = ({ pageSize = 25, page = 1, sort, filters } = {}) =>
  queryOptions({
    placeholderData: keepPreviousData,
    queryKey: ['projects', pageSize, page, sort, filters],
    queryFn: handle401(async () => {
      const { data } = await HttpClient.getProjectsList({ pageSize, page, sort, filters });

      return {
        ...data,
        pageSize: data.page_size,
        totalValue: data.total_value,
        totalSlipping: data.total_slipping,
        totalOnTrack: data.total_on_track,
        totalUpside: data.total_upside,
        totalRedFlags: data.total_red_flags,
        results: data.results.map((project) => ({
          id: project.id,
          name: project.name,
          value: project.project_value,
          startDate: project.start_date,
          targetCloseDate: project.target_close_date,
          likelyEndDate: project.likely_end_date_avg,
          actualEndDate: project.actual_close_date,
          closed: project.closed,
          forecastStatus: project.forecast_status,
          forecaseStatusMonthly: project.forecast_status_monthly,
          percentage: project.percentage_completed,
          projectType: project.project_type,
          priority: project.priority,
          tasksCount: project.total_task_count,
          tasksCompleted: project.completed_task_count,
          archived: project.archived,
          buyerCompany: {
            id: project.buyer_company,
            name: project.buyer_company.name,
            avatarUrl: project.buyer_company.company_image
              ? config.REACT_S3_URL + project.buyer_company.company_image
              : null,
          },
          owner: {
            id: project.owner.id,
            firstName: project.owner.first_name,
            lastName: project.owner.last_name,
            email: project.owner.email,
            avatarUrl: project.owner.avatar,
          },
          maapContacts: project.ext_assignee_count,
          systemStatus: project.system_status,
        })),
      };
    }),
  });

export default projectsListQuery;
